import { appState    , 
         buildDate   } from './build_infos';
		 
import { getModeName , 
         ModeType    } from './app_modes';

export const getAppState = (): number => appState;

export const getMode = (): ModeType => {
  return getModeName(getAppState());
};

export const getAppInformations = (): string => {
  const mode = getMode();
  return `Version du ${buildDate} en mode ${mode}`;
};
